import React from 'react';
import { Lock, Shield, AlertTriangle, CheckCircle, Activity, Clock, TrendingUp } from 'lucide-react';
import { Button } from '../ui/button';

const OTPMonitorTab = ({ otpForm, setOtpForm, monitorOTP, otpResult, otpAlerts, loading }) => (
  <div className="space-y-6">
          <div className="bg-white rounded-xl border shadow-sm p-6">
            <div className="flex items-center justify-between mb-4">
              <h3 className="font-semibold text-gray-900">OTP Interception Detection</h3>
              <Button onClick={() => setShowOtpTest(!showOtpTest)} variant="outline">
                {showOtpTest ? 'Hide Test' : 'Test Detection'}
              </Button>
            </div>
            
            {showOtpTest && (
              <form onSubmit={testOtpInterception} className="space-y-4 mb-6 p-4 bg-gray-50 rounded-lg">
                <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Subscriber ID</label>
                    <input
                      type="text"
                      value={otpForm.subscriber_id}
                      onChange={(e) => setOtpForm({ ...otpForm, subscriber_id: e.target.value })}
                      className="w-full px-3 py-2 border rounded-lg text-sm"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">OTP Type</label>
                    <select
                      value={otpForm.otp_type}
                      onChange={(e) => setOtpForm({ ...otpForm, otp_type: e.target.value })}
                      className="w-full px-3 py-2 border rounded-lg text-sm"
                    >
                      <option value="sms">SMS</option>
                      <option value="voice">Voice Call</option>
                      <option value="authenticator">Authenticator</option>
                    </select>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Service Provider</label>
                    <select
                      value={otpForm.service_provider}
                      onChange={(e) => setOtpForm({ ...otpForm, service_provider: e.target.value })}
                      className="w-full px-3 py-2 border rounded-lg text-sm"
                    >
                      <option value="bank">Bank</option>
                      <option value="social_media">Social Media</option>
                      <option value="email">Email</option>
                      <option value="ecommerce">E-Commerce</option>
                    </select>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Delivery Status</label>
                    <select
                      value={otpForm.delivery_status}
                      onChange={(e) => setOtpForm({ ...otpForm, delivery_status: e.target.value })}
                      className="w-full px-3 py-2 border rounded-lg text-sm"
                    >
                      <option value="delivered">Delivered</option>
                      <option value="delayed">Delayed</option>
                      <option value="failed">Failed</option>
                    </select>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Delivery Time (ms)</label>
                    <input
                      type="number"
                      value={otpForm.delivery_time_ms}
                      onChange={(e) => setOtpForm({ ...otpForm, delivery_time_ms: parseInt(e.target.value) })}
                      className="w-full px-3 py-2 border rounded-lg text-sm"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Source IP</label>
                    <input
                      type="text"
                      value={otpForm.source_ip}
                      onChange={(e) => setOtpForm({ ...otpForm, source_ip: e.target.value })}
                      className="w-full px-3 py-2 border rounded-lg text-sm"
                    />
                  </div>
                </div>
                <Button type="submit" className="bg-blue-600 hover:bg-blue-700">
                  Run Detection
                </Button>
              </form>
            )}
            
            {/* Test Result */}
            {testResult?.type === 'otp' && (
              <div className={`p-4 rounded-lg mb-4 ${
                testResult.data.interception_suspected ? 'bg-red-50 border border-red-200' : 'bg-green-50 border border-green-200'
              }`}>
                <div className="flex items-center gap-2 mb-2">
                  {testResult.data.interception_suspected ? (
                    <AlertTriangle className="h-5 w-5 text-red-600" />
                  ) : (
                    <CheckCircle className="h-5 w-5 text-green-600" />
                  )}
                  <span className="font-semibold">
                    {testResult.data.interception_suspected ? 'OTP INTERCEPTION SUSPECTED!' : 'OTP Delivery Normal'}
                  </span>
                  <span className={`px-2 py-0.5 rounded text-xs ${getSeverityColor(testResult.data.threat_level)}`}>
                    {testResult.data.threat_level?.toUpperCase()}
                  </span>
                </div>
                <p className="text-sm">Risk Score: <strong>{testResult.data.risk_score}</strong></p>
                <p className="text-sm text-blue-600 mt-1">{testResult.data.recommendation}</p>
              </div>
            )}

            {/* Recent Alerts */}
            <h4 className="font-medium text-gray-900 mb-3">Recent OTP Alerts</h4>
            {otpAlerts.length === 0 ? (
              <p className="text-gray-500 text-sm">No high-risk OTP events detected yet</p>
            ) : (
              <div className="space-y-2">
                {otpAlerts.map((alert) => (
                  <div key={alert.id} className={`p-3 rounded-lg border ${getSeverityColor(alert.threat_level)}`}>
                    <div className="flex items-center justify-between">
                      <span className="font-medium">{alert.service_provider} - {alert.otp_type}</span>
                      <span className="text-xs">Score: {alert.risk_score}</span>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
);

export default OTPMonitorTab;
